class PaginationClient extends HTMLElement {
  connectedCallback() {
    this.perPage = parseInt(this.dataset.perPage, 10) || 1;
    this.container = this.closest('.collection');
    this.items = this.container ? Array.from(this.container.querySelectorAll('[data-card-index]')) : [];
    this.totalPages = Math.max(1, Math.ceil(this.items.length / this.perPage));
    this.pageButtons = Array.from(this.querySelectorAll('[data-pagination-page]'));
    this.prevButton = this.querySelector('[data-pagination-prev]');
    this.nextButton = this.querySelector('[data-pagination-next]');

    this.pageButtons.forEach((button) => {
      button.addEventListener('click', () => this.goToPage(parseInt(button.dataset.paginationPage, 10)));
    });
    if (this.prevButton) this.prevButton.addEventListener('click', () => this.goToPage(this.currentPage - 1));
    if (this.nextButton) this.nextButton.addEventListener('click', () => this.goToPage(this.currentPage + 1));

    this.goToPage(1, false);
  }

  goToPage(page, shouldScroll = true) {
    page = Math.min(Math.max(page, 1), this.totalPages);
    this.currentPage = page;
    const start = (page - 1) * this.perPage;
    const end = start + this.perPage;

    this.items.forEach((item, index) => {
      item.hidden = index < start || index >= end;
    });

    this.pageButtons.forEach((button) => {
      const isCurrent = parseInt(button.dataset.paginationPage, 10) === page;
      button.classList.toggle('pagination__item--current', isCurrent);
      if (isCurrent) {
        button.setAttribute('aria-current', 'page');
      } else {
        button.removeAttribute('aria-current');
      }
    });

    if (this.prevButton) this.prevButton.toggleAttribute('disabled', page === 1);
    if (this.nextButton) this.nextButton.toggleAttribute('disabled', page === this.totalPages);

    if (shouldScroll && this.container) {
      this.container.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}

if (!customElements.get('pagination-client')) {
  customElements.define('pagination-client', PaginationClient);
}

class ShowMoreReveal extends HTMLElement {
  connectedCallback() {
    this.perPage = parseInt(this.dataset.perPage, 10) || 1;
    this.container = this.closest('.collection');
    this.items = this.container ? Array.from(this.container.querySelectorAll('[data-card-index]')) : [];
    this.visibleCount = this.perPage;
    this.button = this.querySelector('[data-show-more-button]');

    if (this.button) this.button.addEventListener('click', this.showMore.bind(this));
    this.updateButtonVisibility();
  }

  showMore() {
    this.visibleCount += this.perPage;
    this.items.forEach((item, index) => {
      if (index < this.visibleCount) item.hidden = false;
    });
    this.updateButtonVisibility();
  }

  updateButtonVisibility() {
    if (!this.button) return;
    this.button.hidden = this.visibleCount >= this.items.length;
  }
}

if (!customElements.get('show-more-reveal')) {
  customElements.define('show-more-reveal', ShowMoreReveal);
}
